import { defineAsyncComponent } from 'vue';
import { type App } from '~/app';
import Collapse from 'bootstrap/js/dist/collapse';
import JsController from '~/patterns/components/js-controller';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Microsite-Ribbon-Bar Component');
    const controller = new JsController(app, 'microsite-ribbon-bar')
    controller.addMountFunction(()=>{
        mountMicrositeRibbonBar(controller);
    });
    return controller.init();
};

function mountMicrositeRibbonBar(controller: JsController) {
    const msExitButton = document.querySelector<HTMLElement>('.ms-exit-button');
    const msMenuButton = document.querySelector<HTMLElement>('.ms-menu-button');

    if (msMenuButton && msExitButton) {
        // Function to toggle icons between hamburger and xmark
        const toggleIcons = () => {
            msMenuButton.classList.toggle('hidden');
            msExitButton.classList.toggle('hidden');
        };

        // Show hamburger when xmark is clicked and vice versa
        controller.addListener(msMenuButton, 'click', () => {
            toggleIcons();
        });

        controller.addListener(msExitButton, 'click', () => {
            toggleIcons();
        });
    }
}